<template>
  <div>Accounts</div>
  <UTable :rows="accounts">
    <template #value-header="{ column }">
      <div style="text-align: right">{{ column.label }}</div>
    </template>
    <template #quantity-header="{ column }">
      <div style="text-align: right">{{ column.label }}</div>
    </template>

    <template #value-data="{ row }">
      <div style="text-align: right">{{ row.value.toFixed(2) }} <UBadge variant="soft" size="xs">EUR</UBadge></div>
    </template>

    <template #quantity-data="{ row }">
      <div style="text-align: right">
        {{ row.quantity.toFixed(2) }} <UBadge variant="soft" size="xs">{{ row.currency }}</UBadge>
      </div>
    </template></UTable
  >
</template>

<script setup>
const app = useAppConfig();
const toast = useToast();

const accounts = ref([]);

const refreshAccounts = () => {
  $fetch(app.service + "/positions").then((data) => {
    accounts.value = data;
  });
};

onMounted(() => {
  refreshAccounts();
});
</script>
